import React from 'react';
import { PlanogramComplianceBox } from '../../../types';
import { LayerItem } from './ActionComplianceItem';
import { ACTION_LAYER_CONFIG } from './PlanogramComplianceControlCenter';

interface LayerGroupProps {
  layerKey: string;
  layerLabel: string;
  layerColor: string;
  filteredData: PlanogramComplianceBox[];
  totalCount: number;
  searchText: string;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  cameraImageElement?: HTMLImageElement;
}

export const LayerGroup: React.FC<LayerGroupProps> = ({
  layerKey,
  layerLabel,
  layerColor,
  filteredData,
  totalCount,
  searchText,
  isCollapsed,
  onToggleCollapse,
  cameraImageElement,
}) => {
  return (
    <div className="mb-6">
      <button
        onClick={onToggleCollapse}
        className="w-full flex items-center justify-between font-medium text-gray-900 mb-3 hover:text-gray-700 transition-colors"
      >
        <div className="flex items-center">
          <div className={`w-3 h-3 rounded-full ${layerColor} mr-2`}></div>
          {layerLabel} ({filteredData.length}
          {searchText ? ` of ${totalCount}` : ''})
        </div>
        <svg
          className={`w-5 h-5 transition-transform ${isCollapsed ? '' : 'rotate-180'}`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {!isCollapsed && (
        <div className="space-y-2">
          {filteredData.map((item, index) => {
            const layerConfig = ACTION_LAYER_CONFIG.find(
              (config) => config.key === layerKey
            );
            return (
              <LayerItem
                key={index}
                item={item}
                cameraImageElement={cameraImageElement}
                layerKey={layerKey}
                layerBboxColor={layerConfig?.bboxColor}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
